import React from 'react'
import LetterHead from './LetterHead'
import ReceiptRaw from './ReceiptRaw'

export default function DownloadPdf({data}) {
  return (
    <LetterHead>
        <ReceiptRaw head={"Originator"} text={data.senderName} />
        <ReceiptRaw head={"Reference Number"} text={data.refNum} />
        {
          data && data.type != undefined && data.type != null?
          <ReceiptRaw head={"Transfer Type"} text={data.type} />
          :null
        }
        <ReceiptRaw head={"Transfer Date"} text={data.paydate} />
        <ReceiptRaw head={"Transfer To"} text={data.bank} />
        <ReceiptRaw head={"From Account"} text={data.senderAccount} />
        <ReceiptRaw head={"To Account "} text={data.beneAccount} />
        <ReceiptRaw head={"Payment Amount"} text={data.amount+' LKR'} />
        <ReceiptRaw head={"Bene. Reference"} text={data.bankRef} />
        {
           data && data.startDate != undefined && data.startDate != null?
           <ReceiptRaw head={"Start Date"} text={data.startDate} />
           :null
        }
        {
           data && data.frequency != undefined && data.frequency != null?
           <ReceiptRaw head={"Frequency"} text={data.frequency} />
           :null
        }
        {
           data && data.endDate != undefined && data.endDate != null?
           <ReceiptRaw head={"End Date"} text={data.endDate} />
           :null
        }
         {
           data && data.scheduled != undefined && data.scheduled != null?
           <ReceiptRaw head={"Scheduled Date"} text={data.scheduled} />
           :null
        }
        <ReceiptRaw head={"Status"} text={"Success"} />
    </LetterHead>
  )
}
